import React from 'react'
import styled from 'styled-components'
import Cookies from 'universal-cookie'
import { Link } from 'react-router-dom'

import {
  Container,
  ContainerFlexRow,
  ContainerFlexColumnStart,
  Title,
  Subtitle,
  CustomSubtitle,
  BrushStoke,
  Image,
  ContainerFlexColumn,
  Button,
} from './Utils/CustomClasses'

import { getCurrencySign } from '../utils/utils'
import { shouldTranslateTo } from '../utils/utils'
import { TestimonialsSection, AwardsSection } from './Homepage'
import { gaEvents } from '../analytics/events'

const cookies = new Cookies()

const Header = styled.div`
  height: 90vh;
  max-height: 90vh;

  position: relative;
  background-image: url(${(props) => props.image});
  background-position: 50%, 0;
  background-size: cover;

  background-repeat: repeat, repeat;
  background-attachment: scroll, scroll;

  display: flex;
  flex-direction: row;
  flex: 1;

  @media screen and (max-width: 499px) {
    height: 70vh;
    max-height: 70vh;
  }
`

const HeaderContainerFlexColumnStart = styled(ContainerFlexColumnStart)`
  margin-top: 20vh;
  flex: 0 0 70%;

  h1 {
    color: #fff;
    font-weight: 500;
    padding: 0 0 0 10%;
    align-self: center;
  }

  button {
    margin: 20px 0 0 10%;
    a {
      background-color: #eb5e55;
    }
  }

  @media screen and (max-width: 499px) {
    margin-top: 10vh;
    h1 {
      font-size: 33px;
    }
  }

  @media screen and (min-width: 1100px) {
    flex: 0 0 50%;
  }

  @media screen and (min-width: 1330px) {
    margin-top: 25vh;
  }
`

const MapTitle = styled(Title)`
  font-size: 33px;
  margin: 0 auto;
  text-align: center;
`

const MapSubtitle = styled(Title)`
  font-size: 22px;
  font-weight: normal;
  margin: 0 auto;
  text-align: center;
`

const CustomContainerFlexRow = styled(ContainerFlexRow)`
  flex-wrap: wrap;
`

const CardBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 20%;
  min-width: 200px;

  gap: 45px;

  padding: 40px 20px;
  border-radius: 15px;
  border: 1px solid #e8e8e8;

  background: #fff;
  box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.08);

  img {
    width: 80px;
  }
`

const CustomCardBox = styled(CardBox)`
  flex-basis: 30%;
  min-width: 250px;
  max-width: 310px;
`

const BigButton = styled(Button)`
  a {
    padding: 9px 100px;

    @media screen and (max-width: 600px) {
      padding: 9px 10px;
    }
  }
`

const BkContainerFlexColumn = styled(ContainerFlexColumn)`
  ${(props) =>
    props.image && `background-image: url(${(props) => props.image});`};
  /* background-image: url(${(props) => props.image}); */
  background-size: cover;

  @media screen and (max-width: 768px) {
    background-size: contain;
  }
`

// import { Container } from './styles';

function GiftYourGrownUp() {
  const [pageTextHome, setPageTextHome] = React.useState([])
  const [pageText, setPageText] = React.useState([])
  const [currency, setCurrency] = React.useState('')
  const [currencySign, setCurrencySign] = React.useState('')

  React.useEffect(() => {
    cookies.set('gyguV', 'B', { path: '/' })
    setCurrency(cookies.get('cV'))

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const getCurrency = async () => {
      const data = await getCurrencySign(cookies.get('cV'))
      setCurrencySign(data.sign)
    }
    getCurrency()

    getPageText('homepage', language, setPageTextHome)
    getPageText('GYGU-home', language, setPageText)
  }, [])

  const processClick = (action) => {
    gaEvents.eventGeneric(
      'button_click',
      action,
      'GYGU landing page B - button'
    )
  }

  const Card = ({ image, text }) => {
    return (
      <CardBox>
        <img src={image} />
        <Title
          size="21px"
          sizemd="21px"
          sizesm="21px"
          center
          dangerouslySetInnerHTML={{ __html: `${text}` }}
        />
      </CardBox>
    )
  }

  const CardCustom = ({ image, text }) => {
    return (
      <CustomCardBox>
        <img src={image} />
        <Title
          size="21px"
          sizemd="21px"
          sizesm="21px"
          center
          dangerouslySetInnerHTML={{ __html: `${text}` }}
        />
      </CustomCardBox>
    )
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  if (!currencySign) {
    return
  }
  return (
    <Container>
      {/* Header */}
      <Header image={'images/gygu/gygu-home-header-group-1.jpg'}>
        <HeaderContainerFlexColumnStart
          gap="15px"
          gapMd="15px"
          padding="0"
          paddingSm="0"
        >
          {' '}
          <Title
            dangerouslySetInnerHTML={{
              __html: `Gift your 'grown-up' <strong>fun, friendship</strong> & <strong>freedom</strong> with <strong>lifetime membership</strong> to Freebird Club`,
            }}
          ></Title>
          <BigButton>
            <Link
              id="btn-top-panel"
              to="/gift-your-grown-up/step-1"
              onClick={() => processClick('btn-top-panel')}
              dangerouslySetInnerHTML={{
                __html: `${pageText[3]}`,
              }}
            ></Link>
          </BigButton>
        </HeaderContainerFlexColumnStart>
      </Header>

      {/* Map */}
      <ContainerFlexRow
        gray
        gap="50px"
        padding="10vh 7vw 10vh 7vw"
        paddingSm="4vh 7vw 6vh 7vw"
        paddingMd="7vh 40px 5vh 6vw"
        gapMd="20px"
      >
        <Image width="45vw" widthMd="40vw">
          <img src="/images/gygu/gygu-home-map-group.png" />
        </Image>
        <ContainerFlexColumnStart gap="30px" center>
          <MapTitle
            dangerouslySetInnerHTML={{
              __html: `The social travel club for <b>over 50s</b>`,
            }}
          ></MapTitle>
          <MapSubtitle
            bold
            size="27px"
            sizemd="22px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `Covering <b>28 countries</b> around the world and counting...`,
            }}
          ></MapSubtitle>
        </ContainerFlexColumnStart>
      </ContainerFlexRow>

      {/* Cards */}
      <BkContainerFlexColumn
        center
        padding="2vh 40px 12vh 5vw"
        paddingSm="2vh 8vw 6vh 8vw"
        background="#fff"
      >
        <Title
          smCenter
          size="50px"
          margin="50px auto 30px auto"
          dangerouslySetInnerHTML={{ __html: `${pageText[4]}` }}
        ></Title>
        <CustomContainerFlexRow center gap="40px" gapMd="30px" rowMd>
          <Card image="/images/christimass/card-1.svg" text={pageText[5]} />
          <Card
            image="/images/christimass/card-2.svg"
            text={pageText[6].replace('{{currencyVal}}', currencySign)}
          />
          <Card image="/images/christimass/card-3.svg" text={pageText[7]} />
          <Card image="/images/christimass/card-4.svg" text={pageText[8]} />
        </CustomContainerFlexRow>
      </BkContainerFlexColumn>
      {/* Empower */}
      <ContainerFlexRow
        gray
        gap="50px"
        padding="10vh 7vw 10vh 7vw"
        paddingSm="4vh 7vw 6vh 7vw"
        paddingMd="7vh 40px 5vh 6vw"
        gapMd="20px"
      >
        <Image width="45vw" widthMd="40vw">
          <img src="/images/christimass/people.svg" />
        </Image>
        <ContainerFlexColumnStart gap="30px" center>
          <Title
            dangerouslySetInnerHTML={{
              __html: `${pageText[9]}`,
            }}
          ></Title>
          <Subtitle
            bold
            size="27px"
            sizemd="22px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[10]}`,
            }}
          ></Subtitle>
          <Subtitle
            weight="400"
            size="22px"
            sizemd="18px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[11]}`,
            }}
          ></Subtitle>
          <Subtitle
            bold
            size="22px"
            sizemd="18px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[12]}`,
            }}
          ></Subtitle>
          <BigButton>
            <Link
              id="btn-empower-panel"
              to="/gift-your-grown-up/step-1"
              onClick={() => processClick('btn-empower-panel')}
              dangerouslySetInnerHTML={{
                __html: `${pageText[13]}`,
              }}
            ></Link>
          </BigButton>
        </ContainerFlexColumnStart>
      </ContainerFlexRow>
      {/* Cards 2 */}
      <BkContainerFlexColumn
        center
        padding="12vh 15vw 12vh 15vw"
        paddingSm="6vh 5vw 6vh 5vw"
        background="#F2E8D8"
      >
        <Title
          smCenter
          size="50px"
          margin="0 0 40px 0"
          dangerouslySetInnerHTML={{ __html: `${pageText[14]}` }}
        ></Title>
        <CustomContainerFlexRow center gap="40px" gapMd="30px" rowMd>
          <CardCustom image="/images/christimass/1.svg" text={pageText[15]} />
          <CardCustom image="/images/christimass/2.svg" text={pageText[16]} />
          <CardCustom image="/images/christimass/3.svg" text={pageText[17]} />
          <CardCustom image="/images/christimass/4.svg" text={pageText[18]} />
          <CardCustom image="/images/christimass/5.svg" text={pageText[19]} />
          <CardCustom image="/images/christimass/6.svg" text={pageText[20]} />
        </CustomContainerFlexRow>
      </BkContainerFlexColumn>
      {/* Giftee */}
      <BkContainerFlexColumn
        center
        padding="12vh 15vw 12vh 15vw"
        paddingSm="6vh 5vw 6vh 5vw"
        background="#E1F5F7"
      >
        <Title
          center
          smCenter
          size="50px"
          margin="0 0 40px 0"
          dangerouslySetInnerHTML={{ __html: `${pageText[21]}` }}
        ></Title>
        <CustomSubtitle
          center
          size="22px"
          sizemd="22px"
          sizesm="17px"
          margin="0 0 24px 0"
          marginsm="0 0 0 8px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[22]}`,
          }}
        ></CustomSubtitle>
        <CustomSubtitle
          center
          size="22px"
          sizemd="22px"
          sizesm="17px"
          margin="0 0 100px 0"
          marginsm="0 0 30px 8px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[23]}`,
          }}
        ></CustomSubtitle>
        <BigButton>
          <Link
            id="btn-giftee-panel"
            to="/gift-your-grown-up/step-1"
            onClick={() => processClick('btn-giftee-panel')}
            dangerouslySetInnerHTML={{
              __html: `${pageText[24]}`,
            }}
          ></Link>
        </BigButton>
      </BkContainerFlexColumn>
      {/* Enable */}
      <ContainerFlexRow
        background="#fff"
        gap="50px"
        padding="10vh 7vw 10vh 7vw"
        paddingSm="4vh 7vw 6vh 7vw"
        paddingMd="7vh 40px 5vh 6vw"
        gapMd="20px"
      >
        <ContainerFlexColumnStart gap="20px" center>
          <Title
            dangerouslySetInnerHTML={{
              __html: `${pageText[25]}`,
            }}
          ></Title>
          <CustomSubtitle
            weight="400"
            size="24px"
            sizemd="24px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[26]}`,
            }}
          ></CustomSubtitle>
          <Subtitle
            weight="400"
            size="22px"
            sizemd="18px"
            sizesm="18px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[27]}`,
            }}
          ></Subtitle>
          <BigButton>
            <Link
              id="btn-enable-panel"
              to="/search?seeking=homestays"
              onClick={() => processClick('btn-enable-panel')}
              dangerouslySetInnerHTML={{
                __html: `${pageText[28]}`,
              }}
            ></Link>
          </BigButton>
        </ContainerFlexColumnStart>
        <Image width="40vw" widthMd="40vw">
          <img src="/images/christimass/people-2.svg" />
        </Image>
      </ContainerFlexRow>
      {/* Elevate */}
      <BkContainerFlexColumn
        center
        padding="12vh 15vw 12vh 15vw"
        paddingSm="12vh 5vw 6vh 5vw"
        background="#F8F9F9"
      >
        <Title
          center
          smCenter
          size="50px"
          margin="0 0 40px 0"
          dangerouslySetInnerHTML={{ __html: `${pageText[29]}` }}
        ></Title>
        <BigButton>
          <Link
            id="btn-elevate-panel"
            to="/gift-your-grown-up/step-1"
            onClick={() => processClick('btn-elevate-panel')}
            dangerouslySetInnerHTML={{
              __html: `${pageText[30]}`,
            }}
          ></Link>
        </BigButton>
      </BkContainerFlexColumn>
      {/* Testimonials */}
      <TestimonialsSection pageText={pageTextHome} />
      {/* Awards */}
      <AwardsSection pageText={pageTextHome} />
      {/* Special Someone */}
      <BkContainerFlexColumn
        center
        padding="12vh 15vw 12vh 15vw"
        paddingSm="12vh 5vw 6vh 5vw"
        background="#F2E8D8"
      >
        <Title
          center
          smCenter
          size="50px"
          margin="0 0 40px 0"
          dangerouslySetInnerHTML={{ __html: `${pageText[31]}` }}
        ></Title>
        <BigButton>
          <Link
            id="btn-special-someone-panel"
            to="/gift-your-grown-up/step-1"
            onClick={() => processClick('btn-pecial-someone-panel')}
            dangerouslySetInnerHTML={{
              __html: `${pageText[32]}`,
            }}
          ></Link>
        </BigButton>
      </BkContainerFlexColumn>
    </Container>
  )
}

export default GiftYourGrownUp
